import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiAutenticacaoService } from '../../services/api-autenticacao.service';

export const somenteCadastroPendenteGuard: CanActivateFn = () => {

  const apiAuth = inject(ApiAutenticacaoService);
  const router = inject(Router);
  const usuario = apiAuth.usuarioLogado();

  if (!usuario) { return false; }

  return usuario.cadastroPendente === true ? true : router.parseUrl('/sistemas');
};
